import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage } from 'app/components/core/Snackbar';

export function AddDatasetStartedNotification({ id, onDismiss, type = null }) {
    const { t } = useTranslation();
    const context = type === 'FileUploadStarted' ? 'upload' : 'generic';

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled>
            <SnackbarMessage>{t('notifications:AddDatasetStarted', { context })}</SnackbarMessage>
        </Snackbar>
    );
}

AddDatasetStartedNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    type: PropTypes.string
};
